var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageCategoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.5 6.66699L12.5 6.66699M12.5 6.66699C12.5 8.0477 13.6193 9.16699 15 9.16699C16.3807 9.16699 17.5 8.0477 17.5 6.66699C17.5 5.28628 16.3807 4.16699 15 4.16699C13.6193 4.16699 12.5 5.28628 12.5 6.66699ZM7.5 13.3337L17.5 13.3337M7.5 13.3337C7.5 14.7144 6.38071 15.8337 5 15.8337C3.61929 15.8337 2.5 14.7144 2.5 13.3337C2.5 11.9529 3.61929 10.8337 5 10.8337C6.38071 10.8337 7.5 11.9529 7.5 13.3337Z",
    stroke: "#296C32",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCategoryIcon);
export default __webpack_public_path__ + "static/media/manage_category_icon.202468eb5b1487e9dbd789cab89abaa0.svg";
export { ForwardRef as ReactComponent };